<svg
  display="block"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 629 515"
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
>
  <defs>
    <rect
      id="path-1"
      x="2.27373675e-13"
      y="-5.68434189e-14"
      width="628.5"
      height="515"
      rx="8"
    ></rect>
    <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-3">
      <stop stop-color="#F7F7F7" offset="0%"></stop>
      <stop stop-color="#F4F4F4" offset="100%"></stop>
    </linearGradient>
    <linearGradient x1="50%" y1="0%" x2="50%" y2="99.2504223%" id="linearGradient-4">
      <stop stop-color="#F7F7F7" offset="0%"></stop>
      <stop stop-color="#F4F4F4" offset="100%"></stop>
    </linearGradient>
    <linearGradient x1="50%" y1="100%" x2="50%" y2="-9.59134445%" id="linearGradient-5">
      <stop stop-color="#F7F7F7" offset="0%"></stop>
      <stop stop-color="#F4F4F4" offset="100%"></stop>
    </linearGradient>
    <linearGradient x1="50%" y1="0.567174045%" x2="50%" y2="42.8069526%" id="linearGradient-6">
      <stop stop-color="#F7F7F7" offset="0%"></stop>
      <stop stop-color="#F4F4F4" offset="100%"></stop>
    </linearGradient>
  </defs>
  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Rectangle-14" fill-rule="nonzero">
      <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
      <use fill="#FFFFFF" xlink:href="#path-1"></use>
    </g>
    <path
      d="M8,-1.13686838e-13 L620.5,-1.13686838e-13 C624.918278,-1.14498462e-13 628.5,3.581722 628.5,8 L628.5,44.9603175 L628.5,44.9603175 L2.27373675e-13,44.9603175 L2.27373675e-13,8 C2.26832592e-13,3.581722 3.581722,-1.12875213e-13 8,-1.13686838e-13 Z"
      id="Rectangle-14"
      fill="#F2F3F5"
      fill-rule="nonzero"
    ></path>
    <line x1="0.0568647541" y1="44.8514344" x2="628.443135" y2="44.8514344" id="Line-2"></line>
    <ellipse
      id="Oval-8"
      fill="#FF4E49"
      fill-rule="nonzero"
      cx="21.75"
      cy="22.8888889"
      rx="3.75"
      ry="4.08730159"
    ></ellipse>
    <ellipse
      id="Oval-8-Copy"
      fill="#FFBF00"
      fill-rule="nonzero"
      cx="35.25"
      cy="22.8888889"
      rx="3.75"
      ry="4.08730159"
    ></ellipse>
    <ellipse
      id="Oval-8-Copy-2"
      fill="#00D200"
      fill-rule="nonzero"
      cx="48.75"
      cy="22.8888889"
      rx="3.75"
      ry="4.08730159"
    ></ellipse>
    <rect
      id="Rectangle"
      fill="#F2F3F5"
      transform="translate(314.250000, 323.757310) scale(1, -1) translate(-314.250000, -323.757310) "
      x="-1.36424205e-12"
      y="179.697856"
      width="628.5"
      height="288.118908"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="#FFFFFF"
      x="403"
      y="352.368421"
      width="161"
      height="92.3586745"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="url(#linearGradient-3)"
      x="415"
      y="366.423002"
      width="133"
      height="67.2612086"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="#FFFFFF"
      x="234"
      y="352.368421"
      width="161"
      height="92.3586745"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="url(#linearGradient-4)"
      x="246"
      y="366.423002"
      width="133"
      height="67.2612086"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="#FFFFFF"
      x="63"
      y="352.368421"
      width="161"
      height="92.3586745"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="url(#linearGradient-5)"
      x="75"
      y="366.423002"
      width="133"
      height="67.2612086"
      rx="4"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="32"
      y="135.526316"
      width="171"
      height="5.01949318"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="32"
      y="150.584795"
      width="139"
      height="5.01949318"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="25.7151639"
      y="478.063525"
      width="104"
      height="8.0204918"
      rx="1"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="25.7151639"
      y="492.931922"
      width="104"
      height="8.0204918"
      rx="1"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="227.108607"
      y="492.931922"
      width="173.25"
      height="8.0204918"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="498.784836"
      y="478.063525"
      width="104"
      height="8.0204918"
    ></rect>
    <rect
      id="Rectangle"
      fill="#CBD6E6"
      opacity="0.424990699"
      x="498.784836"
      y="492.931922"
      width="104"
      height="8.0204918"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="#FFFFFF"
      x="63"
      y="207.807018"
      width="502"
      height="132.51462"
      rx="4"
    ></rect>
    <rect
      id="Rectangle-Copy-12"
      fill="url(#linearGradient-6)"
      x="72"
      y="217.171252"
      width="477"
      height="115.448343"
      rx="4"
    ></rect>
    <text
      id="Your-Website"
      font-family="Roboto-Light, Roboto"
      font-size="36"
      font-weight="300"
      fill="#CBD6E6"
    >
      <tspan x="32" y="102.350877">Your Website</tspan>
    </text>
  </g>
</svg>
